var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000069357094849675932630000017060992356861596820_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line-color",
    d: "M22.372,20.563l-4.191-3.588c0.89-1.145,1.378-2.562,1.378-4.009c0-3.607-2.936-6.542-6.544-6.542 c-3.608,0-6.544,2.935-6.544,6.542c0,3.608,2.936,6.545,6.544,6.545c1.517,0,2.991-0.535,4.167-1.509l3.664,4.138 c0.09,0.102,0.22,0.162,0.355,0.164c0.003,0,0.006,0,0.009,0c0.133,0,0.262-0.055,0.353-0.151l0.845-0.883 c0.093-0.097,0.142-0.229,0.135-0.362C22.534,20.773,22.475,20.65,22.372,20.563z M18.339,13.008c0,2.937-2.389,5.325-5.325,5.325 c-2.936,0-5.324-2.389-5.324-5.325c0-2.936,2.389-5.325,5.325-5.325C15.951,7.684,18.339,10.073,18.339,13.008z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 29,
    height: 29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.57935058f214324c2b1901e56c511958.svg";
export { ForwardRef as ReactComponent };